var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"29eda98b60bd48bbaa35dcc511e7c696ab445c43"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dynamic-bus@sentry"]={id:"29eda98b60bd48bbaa35dcc511e7c696ab445c43"};
      